import React, { createContext, useReducer, useContext } from "react";
import CoachesReducer from "../reducers/CoachesReducer";
import AdjuntosService from "../services/AdjuntosService";
import CoachesService from "../services/CoachesService";
import {
  COACHES_RECIBIDAS,
  CREATE_COACH,
  SET_COACH,
  SET_PROPIEDAD_COACH,
} from "../types";
import { getFormDataFile, hideModal } from "../utils";
import { ModalContext } from "./ModalContext";

const initialState = {
  coaches: null,
  coach: null,
};

export const CoachesContext = createContext(initialState);

export const CoachesProvider = ({ children }) => {
  const [state, dispatch] = useReducer(CoachesReducer, initialState);

  const { success } = useContext(ModalContext);

  const getCoaches = () => {
    CoachesService.getCoaches().then((res) => {
      const { instructors } = res.data;
      dispatch({ type: COACHES_RECIBIDAS, payload: instructors });
    });
  };

  const getCoach = (instructor_id) => {
    CoachesService.getSingleCoach(instructor_id).then((res) => {
      const { instructor } = res.data;
      dispatch({ type: SET_COACH, payload: instructor });
    });
  };

  const setCoach = (coach) => {
    dispatch({ type: SET_COACH, payload: coach });
  };

  const setCoaches = (coaches) => {
    dispatch({ type: COACHES_RECIBIDAS, payload: coaches });
  };

  const createCoach = () => {
    dispatch({ type: CREATE_COACH });
  };

  const setPropiedadCoach = (key, value) => {
    dispatch({ type: SET_PROPIEDAD_COACH, payload: { key, value } });
  };

  const postCoach = (coach, callback) => {
    const handleSuccess = () => {
      getCoaches();
      success("¡Coach guardado!");
      if (typeof callback === "function") {
        callback();
      }
      if (!isNaN(coach.instructor_id)) {
        hideModal();
      }
    };

    const savePayload = () => {
      if (coach.customer) {
        coach.user_id = coach.customer.customer_id;
      }
      const payload = { ...coach };
      delete payload.picture;
      const f = payload.file;
      if (
        f &&
        typeof f === "object" &&
        typeof f.size === "number" &&
        typeof f.lastModified === "number"
      ) {
        delete payload.file;
      }

      if (isNaN(coach.instructor_id)) {
        CoachesService.postCoach(payload).then(handleSuccess);
      } else {
        CoachesService.putCoach(payload).then(handleSuccess);
      }
    };

    const promises = [];
    if (coach.picture != null) {
      promises.push(
        new Promise((resolve, reject) => {
          const formData = getFormDataFile(coach.picture, "file");
          AdjuntosService.postAdjunto(formData)
            .then((res) => {
              const { file_id } = res.data;
              coach.file_id = file_id;
              resolve();
            })
            .catch(reject);
        })
      );
    }

    Promise.all(promises).then(savePayload);
  };

  const deleteCoach = (instructor_id) => {
    CoachesService.deleteCoach(instructor_id).then(() => {
      hideModal();
      getCoaches();
    });
  };

  return (
    <CoachesContext.Provider
      value={{
        ...state,
        getCoach,
        setCoach,
        postCoach,
        setCoaches,
        getCoaches,
        createCoach,
        deleteCoach,
        setPropiedadCoach,
      }}
    >
      {children}
    </CoachesContext.Provider>
  );
};
